import { Weekday, WeekdayProps } from '@daypicker/react'

type ExpandedWeekdayProps = WeekdayProps & {
    weekdaysOnly?: boolean
}

export const AstraDayPickerWeekday = ({ weekdaysOnly, ...rest }: ExpandedWeekdayProps) => {
    // hide the column headers for the weekends
    if (weekdaysOnly && (rest.children === 'Lø' || rest.children === 'Sø')) {
        return <></>
    }

    return <Weekday {...rest} />
}
